import React from 'react';
import { MarqueTribe } from './charte/LogoTribe';

/* Cadres des écrans d'accès, d'après les maquettes Connexion, Inscription et
   MotDePasse : fond indigo plein, logo écru posé directement sur l'indigo
   (120 px de haut, sans plaque), et le formulaire dans un bloc écru.

   - CadreAcces (Connexion, Inscription) : à gauche le logo, une accroche et
     une ligne de pied en capitales mono ; à droite le bloc écru.
   - CadreCentre (mot de passe oublié, confirmation d'adresse) : le logo
     centré au-dessus d'un seul bloc écru. */

export const AccrocheConnexion: React.FC = () => (
  <>
    <p className="acces__accroche">
      Le terrain, <span style={{ color: 'var(--orange-clair)' }}>vérifié</span>, livré <span style={{ color: '#7BAA2D' }}>vivant</span>.
    </p>
    <p className="acces__texte">
      Vous commandez une mission, des Spotters certifiés la collectent, chaque donnée est validée deux fois, et vous suivez tout ici.
    </p>
  </>
);

export const CadreAcces: React.FC<{
  children: React.ReactNode;
  accroche?: React.ReactNode;
  pied?: React.ReactNode;
}> = ({ children, accroche = <AccrocheConnexion />, pied }) => (
  <div className="acces">
    <section className="acces__marque">
      <MarqueTribe hauteur={120} mention="AFRICAN DATA MARKETPLACE" alignement="flex-start" />
      <div className="acces__message">{accroche}</div>
      <div className="acces__pied-marque">
        {pied ?? <span>TRIBE SÉNÉGAL SAS · DAKAR</span>}
        <span aria-hidden>·</span>
        <a href="/legal">MENTIONS LÉGALES</a>
      </div>
    </section>
    <main className="acces__colonne">
      <div className="carte-acces">{children}</div>
    </main>
  </div>
);

export const CadreCentre: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="acces acces--centre">
    <MarqueTribe hauteur={120} mention="" />
    <main className="acces__colonne acces__colonne--centre">
      <div className="carte-acces">{children}</div>
    </main>
    <a href="/legal" className="acces__legal">Mentions légales</a>
  </div>
);

/** En-tête d'un bloc écru : étiquette mono orange, titre en Fraunces, texte facultatif. */
export const EnTeteAcces: React.FC<{ etiquette: string; titre: string; children?: React.ReactNode }> = ({ etiquette, titre, children }) => (
  <div className="pile" style={{ gap: '6px' }}>
    <div className="etiquette-mono" style={{ color: 'var(--orange)', letterSpacing: '0.18em' }}>{etiquette}</div>
    <h1 className="carte-acces__titre">{titre}</h1>
    {children && <div style={{ fontSize: '14px', color: 'var(--texte-2)', lineHeight: 1.5 }}>{children}</div>}
  </div>
);

export default CadreAcces;
